import { DeleteOutlined, EyeOutlined, PlusOutlined } from "@ant-design/icons";
import { message, Modal, Upload } from "antd";
import type { RcFile, UploadProps } from "antd/es/upload";
import type { UploadFile } from "antd/es/upload/interface";
import { FC, useEffect, useState } from "react";
import { UploadImagesProps } from "./interface";
import { useAppSelector } from "store";
import { backendUrl } from "config";
import { renameUploadFile } from "helpers/utils";

const getBase64 = (file: RcFile): Promise<string> =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result as string);
    reader.onerror = (error) => reject(error);
  });

const UploadImages: FC<UploadImagesProps> = ({
  maximumUploadItems,
  disabled,
  isEdit,
  value,
  allowFileExtensions,
  onChange,
  typeUpload,
  skuImage,
  setSkuImage,
}) => {
  const accessTokenKey = useAppSelector((state) => state.auth.accessToken);
  const uploadType = typeUpload ? typeUpload : "product";

  // console.log("value--->", value);

  const [previewOpen, setPreviewOpen] = useState(false);
  const [previewImage, setPreviewImage] = useState("");
  const [previewTitle, setPreviewTitle] = useState("");
  const [fileList, setFileList] = useState<UploadFile[] | undefined>(value);

  // const [init, setInit] = useState(false);
  useEffect(() => {
    setFileList(value);
  }, [value]);

  const handleCancel = () => setPreviewOpen(false);
  const handlePreview = async (file: UploadFile) => {
    if (!file.url && !file.preview) {
      file.preview = await getBase64(file.originFileObj as RcFile);
    }

    setPreviewImage(file.url || (file.preview as string));
    setPreviewOpen(true);
    setPreviewTitle(
      file.name || file.url!.substring(file.url!.lastIndexOf("/") + 1)
    );
  };

  const handleChange: UploadProps["onChange"] = ({ file, fileList: changedFileList }) => {
    // อัปโหลดไม่สำเร็จ → เอาออกจากรายการ ไม่งั้นฟอร์มนับว่า "มีรูปแล้ว" แต่ไม่มี id ส่งไปบันทึก
    if (file.status === "error") {
      message.error(`อัปโหลดรูป ${file.name ?? ""} ไม่สำเร็จ กรุณาลองใหม่`);
    }
    const newFileList = changedFileList.filter((item) => item.status !== "error");
    const newFileListUrl = newFileList.map((item) => {
      if (item.response) {
        return {
          ...item,
          url: item.response.url,
          id: item.response.id,
        };
      }
      return item;
    });
    setFileList(newFileListUrl);
    setSkuImage?.(newFileListUrl);
    onChange?.(newFileListUrl);
  };

  const onBeforeUpload: UploadProps["beforeUpload"] = (file) => {
    //change file name
    const newFile = renameUploadFile(file);

    //check file size
    if (file.size > 1024 * 1024 * 5) {
      message.error("ไฟล์ขนาดใหญ่เกิน 5 MB");
      return Upload.LIST_IGNORE;
    }

    return newFile;
  };

  const uploadButton = (
    <div>
      <PlusOutlined style={{ color: "#2777c8" }} />
      <div style={{ marginTop: 8, color: "#2777c8" }}>เพิ่มรูปภาพ</div>
    </div>
  );


  const itemRender = (
    originNode: React.ReactNode,
    file: UploadFile,
    fileList: UploadFile[],
    actions: { remove: () => void }
  ) => {
    return (
      <div className="custom-upload-item">
        <div className="image-container">{originNode}</div>
        <div className="preview-icon">
          <EyeOutlined
            onClick={(e) => {
              e.stopPropagation();
              handlePreview(file);
            }}
          />
        </div>
        <div className="remove-icon">
          <DeleteOutlined
            onClick={(e) => {
              e.stopPropagation();
              actions.remove();
            }}
          />
          </div>
      </div>
    );
  };

  return (
    <>
      <Upload
        disabled={disabled}
        action={`${backendUrl}images/upload?type=${uploadType}`}
        listType="picture-card"
        fileList={fileList}
        onPreview={handlePreview}
        onChange={handleChange}
        maxCount={maximumUploadItems}
        accept={allowFileExtensions}
        itemRender={itemRender}
        onRemove={(file) => {
          const newFileList = fileList?.filter((item) => item.uid !== file.uid);
          setFileList(newFileList);
          onChange?.(newFileList);
        }}
        headers={{
          Authorization: `Bearer ${accessTokenKey}`,
        }}
        beforeUpload={onBeforeUpload}
      >
        {fileList && fileList.length >= maximumUploadItems
          ? null
          : uploadButton}
      </Upload>
      <Modal
        open={previewOpen}
        title={previewTitle}
        footer={null}
        onCancel={handleCancel}
      >
        <img alt="example" style={{ width: "100%" }} src={previewImage} />
      </Modal>
    </>
  );
};

export default UploadImages;
